module.exports = __webpack_public_path__ + "static/media/Meterware_50x50.f0158f43.png";